var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLabelMachineLengthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#ccccff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.03,
    y: 0.01,
    className: "st0",
    width: 24,
    height: 24
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.53,10.29c1.22,0,2.21,0.99,2.21,2.21s-0.99,2.21-2.21,2.21s-2.21-0.99-2.21-2.21S10.3,10.29,11.53,10.29 M11.53,9.29 c-1.78,0-3.21,1.44-3.21,3.21s1.44,3.21,3.21,3.21s3.21-1.44,3.21-3.21S13.3,9.29,11.53,9.29L11.53,9.29z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.86,5c-0.11,0-0.22,0-0.33,0c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5s7.5-3.36,7.5-7.5c0-2.78-1.52-5.21-3.77-6.5 h5.77v-1h-9v0C11.97,5,11.91,5,11.86,5L11.86,5z M11.53,19.01c-3.58,0-6.5-2.92-6.5-6.5s2.92-6.5,6.5-6.5s6.5,2.92,6.5,6.5 S15.11,19.01,11.53,19.01L11.53,19.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLabelMachineLengthIcon);
export default __webpack_public_path__ + "static/media/img_labelMachine_length_icon.40e647fe1dad73aaf99e89b688de6547.svg";
export { ForwardRef as ReactComponent };